import "../assets/css/Historique.css";
import { useNavigate } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";
import { FaLightbulb } from "react-icons/fa6";
import { FaDownload } from "react-icons/fa";
import { useState, useEffect, useCallback } from "react";
import { API_URL } from "../config";


function Historique() {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [filtreStatut, setFiltreStatut] = useState("tous");
  const [historique, setHistorique] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  const [showUserMenu, setShowUserMenu] = useState(false);
  
  const getUsername = () => {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.username || "Admin";
    } catch { return "Admin"; }
  };

  const token = localStorage.getItem("token");


  // Filter by date
  const [dateDebut, setDateDebut] = useState("");
  const [dateFin, setDateFin] = useState("");

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  const fetchHistorique = useCallback(async (page, search, dateDebut, dateFin) => {
    const token = localStorage.getItem("token");
    setLoading(true);

    try {
      let url = `${API_URL}/api/vouchers?page=${page}&limit=10&search=${encodeURIComponent(search)}`;

      if (dateDebut) url += `&dateDebut=${dateDebut}`;
      if (dateFin)   url += `&dateFin=${dateFin}`;

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.ok) {
        const result = await response.json();
        setHistorique(result.data);
        setTotalPages(result.totalPages);
        setTotal(result.total);
      } else if (response.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      }
    } catch (err) {
      console.error("Erreur de chargement", err);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchHistorique(page, search, dateDebut, dateFin);
  }, [page, search, dateDebut, dateFin, fetchHistorique]);


      const filteredData = historique.filter((entry) => {
        const dateCreation = new Date(entry.dateCreation);
        const diffJours = (new Date() - dateCreation) / (1000 * 60 * 60 * 24);
        
        const estVraimentDisponible = entry.estActif && !entry.utilise && diffJours <= 30;
        const estEnCours = entry.estActif && entry.utilise;
        const estExpire = !entry.estActif || (entry.estActif && !entry.utilise && diffJours > 30);

        if (filtreStatut === "disponible") return estVraimentDisponible;
        if (filtreStatut === "utilise") return estEnCours;
        if (filtreStatut === "expire") return estExpire;
        
        const matchSearch = 
          entry.nomClient?.toLowerCase().includes(search.toLowerCase()) ||
          entry.prenomClient?.toLowerCase().includes(search.toLowerCase()) ||
          entry.cle?.toLowerCase().includes(search.toLowerCase());

        return matchSearch;
      });

  // Download PDF
  const handleDownload = async (id) => {
    const token = localStorage.getItem("token");
    try {
        const response = await fetch(`${API_URL}/api/vouchers/${id}/download`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (!response.ok) { alert("Erreur téléchargement"); return; }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `voucher-${id}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert("Erreur réseau");
    }
  };

  // Delete a voucher
  const handleDelete = async (id) => {
    if (!window.confirm("Confirmer la suppression de ce voucher ?"));

    const token = localStorage.getItem("token");
    try {
        const response = await fetch(`${API_URL}/api/vouchers/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.ok) {
        // Remove the voucher from the list without reloading.
        setHistorique(prev => prev.filter(v => v.id !== id));
        setTotal(prev => prev - 1);
      } else {
        alert("Erreur lors de la suppression.");
      }
    } catch (error) {
      alert("Erreur réseau.");
    }
  };

  // Reset date filters
  const resetDates = () => {
    setDateDebut("");
    setDateFin("");
    setPage(1);
  };

  return (
  <div className="page-historique">

    <div className="header-historique">
      <div>
        <h1 className="title-historique">Historique accès Wifi</h1>
        <p className="total-count">{filteredData.length} accès au total</p>
      </div>

    <div className="header-actions">

    
    <div
      className="header-user"
      onClick={(e) => {
        e.stopPropagation();
        setShowUserMenu(!showUserMenu);
      }}
    >
      <div className="header-avatar">
        {getUsername().charAt(0).toUpperCase()}
      </div>

      {showUserMenu && (
        <div className="user-dropdown">
          <div className="user-email-box">
            {getUsername()}
          </div>

          <button
            className="user-dropdown-item logout-item"
            onClick={handleLogout}
          >
            Se déconnecter
          </button>

        </div>
      )}
    </div>

    <button
      className="btn-retour-icon"
      onClick={() => navigate("/wifi-form")}
      title="Retour"
    >
       ← 
    </button>

</div>
    </div>

    <div className="filters-bar">

      {/* Search */}
      <input
        type="text"
        placeholder="Rechercher par nom ou prénom..."
        className="search-bar"
        value={search}
        onChange={(e) => {
          setSearch(e.target.value);
          setPage(1);
        }}
      />

      {/* Statut */}
  
          <select 
              className="filter-select" 
              value={filtreStatut} 
              onChange={(e) => setFiltreStatut(e.target.value)}
            >
                <option value="tous">Tous les statuts</option>
                <option value="disponible">Disponible (Non activé)</option>
                <option value="utilise">Utilisé / En cours</option>
                <option value="expire">Expiré</option>
            </select>

      {/* Dates */}
      <div className="date-filters">
        <span className="date-label">Du</span>
        <input
          type="date"
          className="date-input"
          value={dateDebut}
          onChange={(e) => {
            setDateDebut(e.target.value);
            setPage(1);
          }}
        />

        <span className="date-label">Au</span>
        <input
          type="date"
          className="date-input"
          value={dateFin}
          onChange={(e) => {
            setDateFin(e.target.value);
            setPage(1);
          }}
        />

        {(dateDebut || dateFin) && (
          <button className="btn-reset-date" onClick={resetDates}>
            ✕
          </button>
        )}
      </div>
    </div>

    {/* TABLE */}
    <div className="table-container">
      {loading ? (
        <p className="loading">Chargement...</p>
      ) : (
        <table className="histo-table">
          <thead>
            <tr>
              <th>Date de création</th>
              <th>Auteur de l'accés</th>
              <th>Nom visiteur</th>
              <th>Prénom visiteur</th>
              <th>Clé</th>  
              <th>Expiration</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "30px", color: "#999" }}>
                  Aucun résultat
                </td>
              </tr>
            ) : (
              filteredData.map((entry, i) => (
                <tr key={i}>
                  <td>{new Date(entry.dateCreation).toLocaleDateString("fr-FR")}</td>


                  <td style={{ color: '#555', fontSize: '13px' }}>
                    {entry.userEmail || "Non renseigné"}
                  </td>

                  <td>{entry.nomClient?.toUpperCase()}</td>
                  <td>{entry.prenomClient}</td>
                  <td><code>{entry.cle}</code></td>

                <td>
                  {(() => {
                    // 1. AVAILABLE CASE: Active and unused -> 30-day countdown
                    if (entry.estActif && !entry.utilise) {
                      const dateCreation = new Date(entry.dateCreation);
                      const mtn = new Date();
                      const joursEcoules = Math.floor((mtn - dateCreation) / (1000 * 60 * 60 * 24));
                      const joursRestants = 30 - joursEcoules;

                      return (
                        <span style={{ color: '#f39c12', fontWeight: '500' }}>
                          À activer sous {joursRestants > 0 ? joursRestants : 0} j
                        </span>
                      );
                    }

                    // 2. EXPIRED CASE WITHOUT USE: Inactive and never used
                    if (!entry.utilise) {
                      return <span className="text-muted">Jamais activé</span>;
                    }

                    // 3. USED OR EXPIRED AFTER USE: The actual calculated date is displayed
                    if (entry.dateExpiration) {
                      const dateExp = new Date(entry.dateExpiration);
                      
                      // Security if the date is incorrectly formatted in the database
                      if (isNaN(dateExp.getTime())) return <span className="text-muted">—</span>;

                      return dateExp.toLocaleDateString('fr-FR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      });
                    }

                    return <span className="text-muted">—</span>;
                  })()}
                </td>
    
            <td>
              {(() => {
                // 1. If the voucher is already marked inactive in the database (disabled by Cron)
                if (!entry.estActif) {
                  return <span className="status-expired">Expiré</span>;
                }

                // 2. If the voucher is active but not yet used (30-day verification)
                if (!entry.utilise) {
                  const dateCreation = new Date(entry.dateCreation);
                  const joursDepuisCreation = (new Date() - dateCreation) / (1000 * 60 * 60 * 24);

                  if (joursDepuisCreation > 30) {
                    return <span className="status-expired">Expiré (Non activé)</span>;
                  }
                  return <span className="badge-disponible">Disponible</span>;
                }

                // 3. If the voucher is marked as used
                return (
                  <span className="status-utilise">
                    Utilisé / En cours
                  </span>
                );
              })()}
            </td>

                  <td className="actions-cell">
                    <button
                      className="btn-download"
                      onClick={() => handleDownload(entry.id)}
                    >
                       <FaDownload/>
                    </button>

                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(entry.id)}
                    >
                       <FaTrashAlt/>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>

    {/* PAGINATION */}
    <div className="pagination">
      <button disabled={page === 1} onClick={() => setPage(page - 1)}>
        ‹
      </button>

      <span>Page {page} / {totalPages}</span>

      <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>
        ›
      </button>
    </div>


        {/* Status information help icon */}

        <div className="help-container">
          <button className="help-button" onClick={() => setShowHelp(!showHelp)} title="Aide sur les statuts">
            <FaLightbulb />
          </button>

          {showHelp && (
            <div className="help-popup">
              <h4>Légende des statuts</h4>
              <ul>
                <li><span className="dot disponible"></span> <strong>Disponible :</strong> Code d'accès Wifi créé, pas encore utilisé.</li>
                <li><span className="dot utilise"></span> <strong>Utilisé :</strong> En cours d'utilisation (décompte expiration commencé).</li>
                <li><span className="dot expire"></span> <strong>Expiré :</strong> Code d'accès Wifi ayant atteint sa date d'expiration ou non utilisé après 30 jours.</li>
              </ul>
              <button className="help-close" onClick={() => setShowHelp(false)}>Fermer</button>
            </div>
          )}
        </div>
  </div>
);
}

export default Historique;